import apiClient from './client';
import type { TenantConfig } from '../types';

/**
 * Fetch tenant configuration based on subdomain
 * Note: The tenant subdomain is sent via X-Tenant-Subdomain header
 * (configured in apiClient interceptor in client.ts)
 */
export async function getTenantConfig(): Promise<TenantConfig> {
  // The subdomain is automatically added to the request headers by the apiClient interceptor
  // No need to extract it here or pass it as a parameter
  const response = await apiClient.get<TenantConfig>('public/tenant-config');

  return response.data;
}

/**
 * Check if a subdomain is available
 */
export async function checkSubdomainAvailability(subdomain: string): Promise<boolean> {
  const response = await apiClient.get<{ available: boolean }>(
    '/public/check-subdomain',
    { params: { subdomain } }
  );

  return response.data.available;
}
